const OUTCOMES = [
  ["upcoming", "Upcoming", "#039be5"],
  ["unconfirmed", "Upcoming, unconfirmed", "#e040fb"],
  ["held", "Showed up", "#33b679"],
  ["no_show", "No-show", "#d50000"],
  ["rebooked", "No-show, rebooked", "#f4511e"],
  ["cancelled", "Cancelled", "#8d6e63"],
  ["not_logged", "Show-up not set", "#f6bf26"],
  ["no_lead", "No lead", "#5f6368"],
];
const STAGE_COLORS = { New: "#039be5", "Meet I booked": "#7986cb", "Meet II": "#8e24aa", "Meet III": "#9e69af", Proposed: "#f6bf26", Won: "#33b679", Lost: "#616161", DQ: "#d50000" };
const QUAL = [["qualified", "Qualified", "#33b679"], ["not_qualified", "Not qualified", "#d50000"], ["unmarked", "Not marked yet", "#f6bf26"], ["no_lead", "No lead", "#5f6368"]];
const EXTRA = ["#f4511e", "#0b8043", "#e67c73", "#3f51b5", "#c0ca33", "#ad1457"];

const leadOf = (ev, leads) => leads[ev.lead_ids?.[0]];

export const DEFAULT_COLOUR_RULES = {
  qualified: { field: "qualified_lead", yes: ["Yes"], no: ["No"] },
  show_up: { field: "show_up", yes: ["Yes"], no: ["No"] },
};
const fieldVal = (lead, key) => {
  const v = lead.custom?.[key] ?? lead[key];
  return String(Array.isArray(v) ? v[0] ?? "" : v ?? "").trim().toLowerCase();
};
const inList = (v, list) => v !== "" && (list || []).some((x) => String(x).trim().toLowerCase() === v);

export function categoryOf(ev, leads, mode, rules = DEFAULT_COLOUR_RULES) {
  const lead = leadOf(ev, leads);
  if (mode === "qualified") {
    if (!lead) return "no_lead";
    const r = { ...DEFAULT_COLOUR_RULES.qualified, ...rules.qualified };
    const q = fieldVal(lead, r.field);
    if (inList(q, r.yes)) return "qualified";
    if (inList(q, r.no)) return "not_qualified";
    return "unmarked";
  }
  if (mode === "stage") {
    if (!lead) return "No lead";
    if (lead.module === "dq" || String(lead.qualification || "").toUpperCase() === "DQ") return "DQ";
    return lead.stage || "No stage";
  }
  // Uses the CRM "Show-up" field (custom.show_up Yes/No); a no-show whose lead has a later slot booked counts as rebooked.
  if (ev.crm_status === "cancelled") return "cancelled";
  if (!lead) return "no_lead";
  const start = new Date(ev.start);
  if (new Date(ev.end || ev.start) > new Date()) return ev.confirm === "unconfirmed" ? "unconfirmed" : "upcoming";
  const s = { ...DEFAULT_COLOUR_RULES.show_up, ...rules.show_up };
  const su = fieldVal(lead, s.field);
  if (inList(su, s.yes)) return "held";
  if (inList(su, s.no)) {
    const slot = lead.custom?.slot_time ? new Date(lead.custom.slot_time) : null;
    return slot && slot - start > 3600000 ? "rebooked" : "no_show";
  }
  return "not_logged";
}

// Legend entries [key, label, colour] for the categories present in these events.
export function legendFor(events, leads, mode) {
  if (mode === "qualified") return QUAL;
  if (mode !== "stage") return OUTCOMES;
  const seen = [...new Set(events.map((ev) => categoryOf(ev, leads, "stage")))];
  const order = [...Object.keys(STAGE_COLORS), "No stage", "No lead"];
  seen.sort((a, b) => (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99));
  let i = 0;
  return seen.map((k) => [k, k, STAGE_COLORS[k] || (k === "No lead" || k === "No stage" ? "#5f6368" : EXTRA[i++ % EXTRA.length])]);
}

export function colourEvents(events, leads, mode, hidden, rules) {
  const legend = legendFor(events, leads, mode);
  const col = Object.fromEntries(legend.map(([k, , c]) => [k, c]));
  const counts = {};
  const out = [];
  for (const ev of events) {
    const k = categoryOf(ev, leads, mode, rules);
    counts[k] = (counts[k] || 0) + 1;
    if (!hidden.includes(k)) out.push({ ...ev, _color: col[k] || "#5f6368" });
  }
  return { events: out, legend, counts };
}
